import React, {FC, useEffect, useLayoutEffect, useMemo, useRef, useState} from 'react';
import {
  IChartererOrder,
} from "../../../../../../store/reducers/chartererRequestsReducer/chartererRequestsReducerTypes";
import styled from "styled-components";
import {formatDate, parseStringAsUTCDate, isValidDate} from "../../../../../../utils/helpers/dateHelpers/dateHelpers";
import {calculateArrivalDateFromDuration} from "../../../../../../utils/helpers/dateHelpers/calculateArrivalDate";
import {useAppDispatch, useAppSelector} from "../../../../../../store/store";
import {useUserTimezoneOffset} from "../../../../../../hooks/useUserTimezone";
import {DisplayFullName} from "../../../../../../utils/helpers/textDisplayHelpers/DisplayFullName";
import {DisplayAirport} from "../../../../../../utils/helpers/textDisplayHelpers/DisplayAirport";
import {formatTimezoneOffsetUTC} from "../../../../../../utils/helpers/textDisplayHelpers/DisplayTimezoneOffset";
import {OrderTypeShield} from "../../../../../../components/businessCommon/orderType/OrderTypeShield";
import PaxIcon from "../../../../../../media/icons/pax.svg?react";
import RouteMiniArrowIcon from "../../../../../../media/icons/route_mini_arrow.svg?react";
import MapIcon from "../../../../../../media/icons/map.svg?react";
import DocumentSearchIcon from "../../../../../../media/icons/document-search.svg?react";
import FlagIcon from "../../../../../../media/icons/flag.svg?react";
import FlagFilledIcon from "../../../../../../media/icons/flag_filled.svg?react";
import CloseIcon from "../../../../../../media/icons/close.svg?react";
import ExpandIcon from "../../../../../../media/icons/expand.svg?react";
import {ChatButton} from "../../../../../../components/businessCommon/chat/ChatButton";
import {useChat} from "../../../../../../components/businessCommon/chat/useChat";
import {ChatModal} from "../../../../../../components/businessCommon/chat/ChatModal";
import {CustomButton} from "../../../../../../components/UI/AntCustom/CustomButton";
import {IAirport} from "../../../../../../store/reducers/fleetReducer/fleetReducerTypes";
import {defineMessages, useIntl} from "react-intl";
import {
  defaultCharterOfferStatusesInfo,
  ICharterOfferStatusesInfo,
} from "../../../../../../components/businessCommon/respondsInfo/generateRespondInfo";
import {updateOrderFavorite, getChartererOrderList, updateOrderRequestPlaneStatus, archiveOrder, clearArchiveOrder, getOrderListCounts} from "../../../../../../store/reducers/chartererRequestsReducer/chartererRequestsReducer";
import {clearChangeOrderRequestWithdraw} from "../../../../../../store/reducers/freighterRequestsReducer/freighterRequestsReducer";
import {PastResponsesModal} from "../../../../Shared/components/PastResponsesModal";
import {BookingApiBrokerAcceptPlaneRequest, BookingApiBrokerDeclinePlaneRequest} from "../../../../../../proto/generated/api_entities_pb";
import {Logger} from "../../../../../../utils/logger/Logger";
import {BookingApi} from "../../../../../../API/ApiClasses/BookingApi";
import {message as antdMessage} from "antd";
import Modal from "antd/es/modal/Modal";
import {MapContainer, TileLayer, useMap} from "react-leaflet";
import {LatLngExpression, LatLngTuple, latLngBounds, point} from "leaflet";
import {createPortal} from "react-dom";
import {mediaScreenSizes} from "../../../../../../utils/constans/styles/screenSizes";
import {useIsMobile} from "../../../../../../hooks/useWindowSize";
import {DisplayPlaneCategories} from "../../../../../../utils/helpers/textDisplayHelpers/DisplayPlaneCategories";
import {DisplayYesOrNo} from "../../../../../../utils/helpers/textDisplayHelpers/DisplayYesOrNo";
import {CommonDetailsMessages} from "../../../../../../intl/commonMessages/CommonDetailsMessages";
import {CommonFormMessages} from "../../../../../../intl/commonMessages/CommonFormMessages";
import RouteArrowIcon from "../../../../../../media/icons/route_arrow.svg?react";
import {IChartererOrderRequestFromOrder} from "../../../../../../store/reducers/chartererRequestsReducer/chartererRequestsReducerTypes";
import {PlaneImage} from "../../../../../../components/businessCommon/planeImage/PlaneImage";
import {ChatButton as AircraftChatButton} from "../../../../../../components/businessCommon/chat/ChatButton";
import {useChat as useAircraftChat} from "../../../../../../components/businessCommon/chat/useChat";
import {ChatModal as AircraftChatModal} from "../../../../../../components/businessCommon/chat/ChatModal";
import {DisplayFlyPrice} from "../../../../../../utils/helpers/textDisplayHelpers/DisplayFlyPrice";
import {useCurrencyConverter} from "../../../../../../hooks/useCurrencyConverter";
import {getBaseCurrencyId, getBaseCurrencyInfo} from "../../../../../../utils/helpers/currencyConverter/currencyConverter";
import {OrderRequestStatusEnum, OrderRequestPlaneStatusEnum} from "../../../../../../utils/constans/statuses/orderRequestStatuses";
import {IOrderRequestPlane} from "../../../../../../store/reducers/freighterRequestsReducer/freighterRequestsReducerTypes";
import {AcceptButton} from "../../../../../../components/UI/Buttons/AcceptButton";
import {DeclineButton} from "../../../../../../components/UI/Buttons/DeclineButton";
import {CustomDrawer} from "../../../../../../components/UI/AntCustom/CustomDrawer";
import {FlightDrawerPlane} from "../../../../../../components/businessCommon/flightDrawer/plane/FlightDrawerPlane";
import {PlanePhotos} from "../../../../../../pages/Lk/OperatorsOnly/Fleet/components/PlanePhotos";
import {FlightDrawerPhotosAndContentWrapper, FlightDrawerContentWrapper} from "../../../../../../components/businessCommon/flightDrawer/wrappers/FlightDrawerStyledComponents";
import {
  OrderOrderRequestFlightDrawer
} from "../../../../../../components/businessCommon/flightDrawer/wrappers/OrderOrderRequestFlightDrawer";
import InfoIcon from "../../../../../../media/icons/info-icon.svg?react";
import {RenderConfirmModal} from "../../../../../../components/UI/StatusModals/renderSuccessModal";


const OrderCardWrapper = styled.div`
  background: #FAFAFA;
  border: 1px solid #D9D9D9;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const MapModal = styled(Modal)`
  &.ant-modal {
    margin: 0 auto;
  }

  .ant-modal-content {
    padding: 0;
    border-radius: 20px;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-close {
    display: none;
  }

  @media (max-width: 982px) {
    &.ant-modal {
      width: 100% !important;
      margin: 0;
      padding: 0;
      max-width: 100%;
    }

    .ant-modal-content {
      border-radius: 0;
    }
  }
`;

const MapModalContent = styled.div`
  display: flex;
  width: 950px;
  height: 568px;
  flex-direction: column;
  align-items: stretch;
  border-radius: 20px;
  background: #FFF;
  position: relative;

  @media (max-width: 982px) {
    width: 100vw;
  }

  @media (max-width: ${mediaScreenSizes.mobile}) {
    height: 538px;
  }
`;

const MapModalHeader = styled.div`
  display: flex;
  padding: 16px 32px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid #DDDDDC;

  @media (max-width: ${mediaScreenSizes.mobile}) {
    padding: 16px;
  }
`;

const MapModalBody = styled.div`
  flex: 1;
  margin-top: 32px;
  padding: 0 32px 0 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: ${mediaScreenSizes.mobile}) {
    margin-top: 16px;
    padding: 0 16px 0 16px;
  }
`;

const MapWrapper = styled.div`
  width: 100%;
  height: 416px;
  position: relative;
  overflow: visible;
`;

const MapInnerWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
`;

const MapRouteOverlay: React.FC<{
  points: LatLngTuple[];
  markerRadius: number;
  plane?: {segmentIndex: number; progress: number} | null;
  popupSegments?: Array<{from: string; to: string; departure: string | null; arrival: string | null} | null>;
  popupRoot?: HTMLDivElement | null;
  popupLabels: {trip: string; departure: string; arrival: string};
}> = ({points, markerRadius, plane, popupSegments, popupRoot, popupLabels}) => {
  const map = useMap();
  const [tick, setTick] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [selectedPointIndex, setSelectedPointIndex] = useState<number | null>(null);
  const popupRef = useRef<HTMLDivElement | null>(null);
  const [popupSize, setPopupSize] = useState({width: 0, height: 0});
  const [container] = useState(() => {
    const el = document.createElement("div");
    el.style.position = "absolute";
    el.style.inset = "0";
    el.style.pointerEvents = "none";
    el.style.zIndex = "400";
    return el;
  });
  const [popupContainer] = useState(() => {
    const el = document.createElement("div");
    el.style.position = "absolute";
    el.style.inset = "0";
    el.style.pointerEvents = "none";
    el.style.zIndex = "401";
    return el;
  });

  useEffect(() => {
    const mapContainer = map.getContainer();
    const overlayParent = mapContainer.parentElement?.parentElement || mapContainer;
    overlayParent.appendChild(container);
    return () => {
      container.remove();
    };
  }, [map, container]);

  useEffect(() => {
    const mapContainer = map.getContainer();
    const root = popupRoot || mapContainer.parentElement?.parentElement || mapContainer;
    root.appendChild(popupContainer);
    return () => {
      popupContainer.remove();
    };
  }, [map, popupRoot, popupContainer]);

  useEffect(() => {
    const start = () => setIsAnimating(true);
    const end = () => {
      setIsAnimating(false);
      setTick((v) => v + 1);
    };
    const resize = () => setTick((v) => v + 1);
    const clearSelection = () => setSelectedPointIndex(null);

    map.on("zoomstart movestart", start);
    map.on("zoomend moveend", end);
    map.on("resize", resize);
    map.on("click", clearSelection);
    return () => {
      map.off("zoomstart movestart", start);
      map.off("zoomend moveend", end);
      map.off("resize", resize);
      map.off("click", clearSelection);
    };
  }, [map]);

  const size = map.getSize();
  const pixelBounds = map.getPixelBounds();
  const boundsMin = pixelBounds.min ?? point(0, 0);
  const boundsMax = pixelBounds.max ?? point(size.x, size.y);
  const worldWidth = map.getPixelWorldBounds().getSize().x || size.x;
  const zoom = map.getZoom();

  const worldPoints = useMemo(() => {
    if (points.length < 2) return [];
    return points.map((pt) => map.project(pt, zoom));
  }, [points, map, zoom, tick]);

  const segments = useMemo(() => {
    if (worldPoints.length < 2) return [];
    const result: Array<{from: {x: number; y: number}; to: {x: number; y: number}; arrow: boolean}> = [];

    const xmin = boundsMin.x;
    const xmax = boundsMax.x;
    const ymin = boundsMin.y;
    const ymax = boundsMax.y;

    const clipLine = (p0: {x: number; y: number}, p1: {x: number; y: number}) => {
      // Liang–Barsky
      let t0 = 0;
      let t1 = 1;
      const dx = p1.x - p0.x;
      const dy = p1.y - p0.y;
      const p = [-dx, dx, -dy, dy];
      const q = [p0.x - xmin, xmax - p0.x, p0.y - ymin, ymax - p0.y];

      for (let i = 0; i < 4; i += 1) {
        if (p[i] === 0) {
          if (q[i] < 0) return null;
        } else {
          const r = q[i] / p[i];
          if (p[i] < 0) {
            if (r > t1) return null;
            if (r > t0) t0 = r;
          } else {
            if (r < t0) return null;
            if (r < t1) t1 = r;
          }
        }
      }

      const c0 = {x: p0.x + t0 * dx, y: p0.y + t0 * dy};
      const c1 = {x: p0.x + t1 * dx, y: p0.y + t1 * dy};
      return {c0, c1, t0, t1};
    };

    for (let i = 1; i < worldPoints.length; i += 1) {
      const from = worldPoints[i - 1];
      const to = worldPoints[i];

      const candidates = [0, -worldWidth, worldWidth].map((shift) => ({
        from: point(from.x + shift, from.y),
        to: point(to.x + shift, to.y),
      }));

      const best = candidates.reduce((bestCandidate, candidate) => {
        const clipped = clipLine(candidate.from, candidate.to);
        if (!clipped) return bestCandidate;
        const len = Math.hypot(clipped.c1.x - clipped.c0.x, clipped.c1.y - clipped.c0.y);
        if (!bestCandidate || len > bestCandidate.len) {
          return {candidate, clipped, len};
        }
        return bestCandidate;
      }, null as null | {candidate: {from: {x: number; y: number}; to: {x: number; y: number}}; clipped: {c0: {x: number; y: number}; c1: {x: number; y: number}; t0: number; t1: number}; len: number});

      if (!best) continue;

      const fullFrom = best.candidate.from;
      const fullTo = best.candidate.to;
      const clipped = best.clipped;

      // If the line crosses the viewport, we may need to split at the edge
      if (clipped.t0 > 0) {
        result.push({from: fullFrom, to: clipped.c0, arrow: false});
      }
      result.push({from: clipped.c0, to: clipped.c1, arrow: true});
    }

    return result;
  }, [worldPoints, boundsMin.x, boundsMax.x, boundsMin.y, boundsMax.y, worldWidth]);

  const planePoint = useMemo(() => {
    if (!plane) return null;
    const {segmentIndex, progress} = plane;
    if (segmentIndex < 0 || segmentIndex >= worldPoints.length - 1) return null;
    const from = worldPoints[segmentIndex];
    const to = worldPoints[segmentIndex + 1];
    const x = from.x + (to.x - from.x) * progress;
    const y = from.y + (to.y - from.y) * progress;
    const angle = progress > 0 && progress < 1
      ? Math.atan2(to.y - from.y, to.x - from.x) * 180 / Math.PI
      : 0;
    return {x, y, angle};
  }, [plane, worldPoints]);

  const selectedSegmentIndex = selectedPointIndex === null
    ? null
    : Math.min(
      Math.max(0, selectedPointIndex - 1),
      (popupSegments?.length || 0) - 1
    );

  const popupData = (selectedSegmentIndex !== null && popupSegments)
    ? popupSegments[selectedSegmentIndex]
    : null;

  useLayoutEffect(() => {
    if (!popupRef.current) return;
    const rect = popupRef.current.getBoundingClientRect();
    setPopupSize({width: rect.width, height: rect.height});
  }, [popupData, selectedPointIndex, tick]);

  const popupPosition = useMemo(() => {
    if (!popupData || selectedPointIndex === null) return null;
    const mapRect = map.getContainer().getBoundingClientRect();
    const root = popupRoot || map.getContainer().parentElement?.parentElement || map.getContainer();
    const rootRect = root.getBoundingClientRect();
    const anchorX = worldPoints[selectedPointIndex].x - boundsMin.x + (mapRect.left - rootRect.left);
    const anchorY = worldPoints[selectedPointIndex].y - boundsMin.y + (mapRect.top - rootRect.top);
    const padding = 8;
    const left = Math.min(
      Math.max(anchorX - popupSize.width / 2, padding),
      Math.max(padding, rootRect.width - popupSize.width - padding)
    );
    const top = Math.min(
      Math.max(anchorY - popupSize.height - 8, padding),
      Math.max(padding, rootRect.height - popupSize.height - padding)
    );
    return {left, top};
  }, [
    popupData,
    selectedPointIndex,
    worldPoints,
    boundsMin.x,
    boundsMin.y,
    map,
    popupRoot,
    popupSize.width,
    popupSize.height,
  ]);

  if (points.length < 2) return null;

  if (isAnimating) {
    return null;
  }

  return (
    <>
      {createPortal(
        <svg width={size.x} height={size.y} key={tick} style={{pointerEvents: "none"}}>
          <defs>
            <marker
              id="route-arrow"
              markerWidth="10"
              markerHeight="10"
              refX="9"
              refY="5"
              orient="auto"
              markerUnits="userSpaceOnUse"
            >
              <polygon points="0,0 10,5 0,10" fill="#000" />
            </marker>
            <symbol id="plane-icon" viewBox="0 0 16 16">
              <path
                d="M4.28 15.5205H5.88L9.4704 9.11967H13.6C13.6 9.11967 16 9.11967 16 8.00047C16 6.88047 13.6 6.88047 13.6 6.88047H9.4704L5.88 0.480469H4.28L6.2704 6.88047H3.4008L1.6 5.27967H0L1.2808 7.99967L0 10.7205H1.6L3.4008 9.11967H6.2704L4.28 15.5205Z"
                fill="#000"
              />
            </symbol>
          </defs>
          {segments.map((segment, index) => {
            const from = {
              x: segment.from.x - boundsMin.x,
              y: segment.from.y - boundsMin.y,
            };
            const to = {
              x: segment.to.x - boundsMin.x,
              y: segment.to.y - boundsMin.y,
            };
            let endX = to.x;
            let endY = to.y;
            if (segment.arrow) {
              const dx = to.x - from.x;
              const dy = to.y - from.y;
              const len = Math.sqrt(dx * dx + dy * dy) || 1;
              const ux = dx / len;
              const uy = dy / len;
              const arrowOffset = markerRadius + 6; // px: keep arrow tip on circle edge
              endX = to.x - ux * arrowOffset;
              endY = to.y - uy * arrowOffset;
            }
            return (
              <line
                key={`segment-${index}`}
                x1={from.x}
                y1={from.y}
                x2={endX}
                y2={endY}
                stroke="#000"
                strokeWidth="2"
                strokeDasharray="6 6"
                markerEnd={segment.arrow ? "url(#route-arrow)" : undefined}
              />
            );
          })}
        {worldPoints.map((p, index) => (
          <circle
            key={`point-${index}`}
            cx={p.x - boundsMin.x}
            cy={p.y - boundsMin.y}
            r={markerRadius}
            fill="#000"
            style={{cursor: "pointer", pointerEvents: "auto"}}
            onClick={(event) => {
              event.stopPropagation();
              setSelectedPointIndex(index);
            }}
            onMouseEnter={() => {
              map.getContainer().style.cursor = "pointer";
            }}
            onMouseLeave={() => {
              map.getContainer().style.cursor = "";
            }}
          />
        ))}
        {planePoint && (
          <g
            transform={`translate(${planePoint.x - boundsMin.x} ${planePoint.y - boundsMin.y}) rotate(${planePoint.angle}) translate(-8 -8)`}
          >
            <use href="#plane-icon" width="16" height="16" />
          </g>
        )}
        </svg>,
        container
      )}
      {popupData && selectedPointIndex !== null && popupPosition &&
        createPortal(
          <MapPointPopup
            ref={popupRef}
            style={{
              left: popupPosition.left,
              top: popupPosition.top,
            }}
          >
            <div>
              <MapPointPopupLabel>{popupLabels.trip}</MapPointPopupLabel>
              <MapPointPopupValue>{popupData.from} → {popupData.to}</MapPointPopupValue>
            </div>
            {popupData.departure && (
              <div>
                <MapPointPopupLabel>{popupLabels.departure}</MapPointPopupLabel>
                <MapPointPopupValue>{popupData.departure}</MapPointPopupValue>
              </div>
            )}
            {popupData.arrival && (
              <div>
                <MapPointPopupLabel>{popupLabels.arrival}</MapPointPopupLabel>
                <MapPointPopupValue>{popupData.arrival}</MapPointPopupValue>
              </div>
            )}
          </MapPointPopup>,
          popupContainer
        )}
    </>
  );
};

const MapSizeUpdater: React.FC<{isOpen: boolean; hasRoute: boolean}> = ({isOpen, hasRoute}) => {
  const map = useMap();

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const raf = requestAnimationFrame(() => map.invalidateSize());
    const timeout = window.setTimeout(() => {
      map.invalidateSize();
      if (hasRoute) {
        const nextZoom = map.getZoom() + 1;
        const maxZoom = map.getMaxZoom() || 18;
        map.setZoom(Math.min(nextZoom, maxZoom));
      }
    }, 150);

    return () => {
      cancelAnimationFrame(raf);
      window.clearTimeout(timeout);
    };
  }, [isOpen, hasRoute, map]);

  return null;
};

const MapModalRouteText = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: #000;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.14px;
`;

const MapModalTitle = styled.div`
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;

const MapModalCloseButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const MapPointPopup = styled.div`
  position: absolute;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 12px;
  line-height: 120%;
  color: #000;
  pointer-events: auto;
  z-index: 2;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.30), 0 2px 6px 2px rgba(0, 0, 0, 0.15);
  padding: 16px;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -6px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #ffffff;
  }

  &::before {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -7px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid #e5e5e5;
  }
`;

const MapPointPopupLabel = styled.div`
  font-size: 11px;
  color: #808080;
`;

const MapPointPopupValue = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #000;
`;

const OrderCardHeader = styled.div`
  background: #FAFAFA;
  display: flex;
  gap: 21px;
  align-items: center;
  border-radius: 12px 12px 0 0;
`;

const OrderCardMainRow = styled.div`
  display: flex;
  gap: 21px;
  align-items: center;
  width: 100%;

  @media (max-width: 1360px) {
    flex-wrap: wrap;
  }
`;

const VerticalDividerStyled = styled.div`
  width: 1px;
  height: 50px;
  background: #D9D9D9;
  flex-shrink: 0;
`;

const BrokerInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  width: 118.834px;
  font-family: Inter, sans-serif;
  
  div:first-child {
    color: #040404;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  }
  
  div:nth-child(2) {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.14px;
  }

  @media (min-width: 650px) and (max-width: 1360px) {
    order: -4;
    width: calc(100% - 230px);
  }

  @media (max-width: 651px) {
    order: -3;
    width: 100%;
  }
`;

const LastModifiedText = styled.div`
  color: #808080;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  margin-top: 2px;
`;

const OrderCardChatButton = styled(ChatButton)`
  @media (min-width: 651px) and (max-width: 1360px) {
    order: -3;
  }

  @media (max-width: 650px) {
    order: -1;
  }
`;

const OrderTypeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  justify-content: center;
  width: 78px;
`;

const RouteSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 173px;

  @media (min-width: 651px) and (max-width: 1360px) {
    order: -1;
    width: calc(100% - 376px);
  }

  @media (max-width: 650px) {
    order: -2;
    width: 100%;
  }
`;

const LargeScreenVerticalDividerStyled = styled(VerticalDividerStyled)`
  @media (max-width: 1360px) {
    display: none;
  }
`;

const RouteDate = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  color: #808080;
`;

const RouteAirports = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  
  div {
    font-weight: 600;
    font-size: 14px;
    line-height: 1.2;
    color: #000000;
    letter-spacing: -0.14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const RouteAirportsMore = styled.div`
  cursor: pointer;
  color: #1890FF !important;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.01em;
`;

const ShowMapLink = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  color: #1890FF;
  
  svg {
    width: 12px;
    height: 12px;
  }
  
  div {
    font-weight: 400;
    font-size: 11px;
    line-height: 1.2;
    color: #1890FF;
    letter-spacing: -0.11px;
    white-space: nowrap;
  }
`;

const PaxSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 36px;
  align-self: flex-start;
  
  div:first-child {
    font-weight: 400;
    font-size: 11px;
    line-height: 1.2;
    color: #808080;
  }
  
  div:last-child {
    display: flex;
    gap: 6px;
    align-items: center;
    
    svg {
      width: 13.812px;
      height: 13.283px;
      
      path {
        fill: #000000;
      }
    }
    
    div {
      font-weight: 600;
      font-size: 12px;
      line-height: 1.2;
      color: #000000;
      letter-spacing: -0.12px;
      white-space: nowrap;
    }
  }
`;

const JetsStatusSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 133px;
  align-self: flex-start;
`;

const JetsStatusLabel = styled.div`
  font-weight: 400;
  font-size: 11px;
  line-height: 1.2;
  color: #808080;
`;

const JetsStatusRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 111px;
`;

const JetsStatusBadge = styled.div<{isApproved: boolean}>`
  width: 24px;
  height: 24px;
  border-radius: 23px;
  background: ${props => props.isApproved ? '#D6E6CD' : '#D9D9D9'};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  color: #000000;
`;

const JetsStatusDot = styled.div`
  position: absolute;
  top: -2.5px;
  left: 16.53px;
  width: 8.937px;
  height: 9px;
  background: #1890FF;
  border-radius: 18px;
`;

const JetsStatusText = styled.div`
  font-weight: 700;
  font-size: 12px;
  line-height: 1.2;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 77px;
`;

const JetsStatusDetails = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 1.2;
  color: #808080;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ActionsSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding-left: 0px;
  
  @media(max-width: ${mediaScreenSizes.mobile}) {
    padding-left: 0;
  }

  @media (min-width: 651px) and (max-width: 1360px) {
    order: -2;
    padding-left: 0;
  }

  @media (max-width: 650px) {
    order: 1;
    justify-content: flex-end;
    width: 100%;
  }
`;

const ActionButtonWrapper = styled(CustomButton)`
  width: 45px;
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FAFAFA;
  border: 1px solid #D9D9D9;
  border-radius: 5px;
  
  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    border-color: #1890FF;
  }
`;

const FavoriteButtonWrapper = styled(CustomButton)<{ $isFavorite?: boolean }>`
  width: 45px;
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FAFAFA;
  border: 1px solid ${props => props.$isFavorite ? '#1890FF' : '#D9D9D9'};
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.88);

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    border-color: #1890FF !important;
    color: rgba(0, 0, 0, 0.88) !important;
  }
`;

const ExpandButtonWrapper = styled.div<{ $isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 27px;
  border-radius: 16px;
  cursor: pointer;
  transform: rotate(${({$isExpanded}) => $isExpanded ? '180deg' : '0deg'});
  transition: transform 0.2s ease;
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

const ExpandedSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ItineraryCard = styled.div`
  background: #FFFFFF;
  border: 1px solid #D9D9D9;
  border-radius: 5px;
  padding: 16px 24px;
  position: relative;
`;

const ItineraryContent = styled.div`
  display: flex;
  gap: 0;
  align-items: flex-start;
  position: relative;

  @media (max-width: 630px) {
    flex-direction: column;
  }
`;

const ItineraryRouteSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;

  @media (max-width: 630px) {
    width: 100%;
    min-width: 100%;
    gap: 16px;
  }
`;

const ItineraryVerticalDivider = styled(VerticalDividerStyled)`
  @media (max-width: 630px) {
    display: none;
  }
`;

const RouteFromToWrapper = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  position: relative;

  @media (max-width: 540px) {
    flex-direction: column;
  }
`;

const RouteFromToItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  align-items: flex-start;
`;

const RouteFromToDate = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  opacity: 0.5;
`;

const RouteAirportCode = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 22px;
  color: #000000;
  letter-spacing: -0.2px;
`;

const RouteAirportLocation = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: #000000;
  opacity: 0.5;
`;

const RouteArrowWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  align-self: flex-start;
  padding-top: 3px;
`;

const PaxRequestedSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
  flex-shrink: 0;
  min-width: fit-content;

  @media (max-width: 630px) {
    padding-top: 16px;
    width: 100%;
    gap: 8px
  }
`;

const PaxRequestedLabel = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  opacity: 0.5;
  letter-spacing: -0.14px;
  white-space: nowrap;
`;

const PaxRequestedCount = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.2;
  color: #000000;
  letter-spacing: -0.16px;
`;

const InfoCard = styled.div`
  background: #FFFFFF;
  border: 1px solid #D9D9D9;
  border-radius: 5px;
  padding: 14px 10px;
  position: relative;
  height: 49px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const InfoCardLeft = styled(InfoCard)`
  width: 897px;

  @media (min-width: 481px) and (max-width: 780px) {
    width: 70%;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const InfoCardRight = styled(InfoCard)`
  width: 182px;

  @media (min-width: 481px) and (max-width: 780px) {
    width: 30%;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;


const InfoCardLabel = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 10px;
  line-height: 1.2;
  color: #000000;
  opacity: 0.5;
  margin-bottom: 3px;
`;

const InfoCardValue = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.2;
  color: #000000;
`;

const InfoCardsRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
  flex-wrap: nowrap;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 8px;
  }
`;

const AircraftOptionsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const AircraftOptionsTitle = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  color: #000000;
`;

const AircraftOptionsCard = styled.div`
  background: #FAFAFA;
  border: 1px solid #E4E4E4;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
`;

const AircraftCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 0 24px;

  @media (max-width: 1100px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const AircraftCardHeaderLeft = styled.div`
  display: flex;
  gap: 36px;
  align-items: center;

  @media (min-width: 526px) and (max-width: 1100px) {
    width: 100%;
    gap: 16px;
    justify-content: space-between;
  }

  @media (max-width: 525px) {
    gap: 8px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const AircraftCardHeaderLeftBlock = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
`;

const AircraftCardNameBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const AircraftCardName = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  letter-spacing: -0.14px;
  white-space: nowrap;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`;

const AircraftCardDottedLine = styled.div`
  width: 140.383px;
  height: 1px;
  background-image: repeating-linear-gradient(
    to right,
    #000 0px,
    #000 14.048px,
    transparent 14.048px,
    transparent 18.048px
  );
  margin-top: 1px;
`;

const AircraftCardCompany = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const AircraftCardCompanyName = styled.div`
  display: flex;
    gap: 8px;
  align-items: center;

  @media (max-width: 1100px) {
   gap: 16px;
  }
`;

const AircraftCardCompanyText = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
  width: 200px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 1100px) {
    width: auto;
  }
`;

const AircraftCardHeaderRight = styled.div`
  display: flex;
  gap: 39px;
  align-items: center;

  @media (min-width: 526px) and (max-width: 1100px) {
    width: 100%;
    justify-content: flex-end;
  }

  @media (max-width: 525px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
`;

const AircraftCardPriceBlock = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-start;
  min-width: 100px;
  flex-direction: column;

  @media (max-width: ${mediaScreenSizes.mobile}) {
    min-width: auto;
    width: auto;
  }
`;

const AircraftCardPrice = styled.div`
  color: #000000;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.2px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  
  > *:first-child {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: ${mediaScreenSizes.mobile}) {
    font-size: 16px;
    line-height: 18px;
  }
`;

const AircraftCardPriceMain = styled.span`
  white-space: nowrap;
  display: inline-block;
  max-width: 100%;

  @media (max-width: ${mediaScreenSizes.mobile}) {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const AircraftCardPriceSecondary = styled.div`
  color: #666666;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
`;

const AircraftCardPriceContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: flex-start;
`;

const InfoIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

const AircraftCardStatusBlock = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
`;

const AircraftCardStatusBadge = styled.div<{ $status: OrderRequestPlaneStatusEnum | undefined }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  padding: 2px 13px;
  border-radius: 23px;
  width: 100px;
  background: ${({$status}) => {
    // Green for offered by operator or approved by broker
    if ($status === OrderRequestPlaneStatusEnum.STATUS_OFFERED_BY_OPERATOR || $status === OrderRequestPlaneStatusEnum.STATUS_APPROVED_BY_BROKER) return "#D6E6CD";
    // Red for declined (by operator or broker)
    if ($status === OrderRequestPlaneStatusEnum.STATUS_DECLINED_BY_OPERATOR || $status === OrderRequestPlaneStatusEnum.STATUS_DECLINED_BY_BROKER) return "#E7C4C4";
    // Grey for pending
    return "#E0E0E0";
  }};
`;

const AircraftCardStatusText = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  color: #000000;
  white-space: nowrap;
`;

const AircraftCardActions = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
  width: 72px; /* 32px (кнопка) + 8px (gap) + 32px (кнопка) */
  justify-content: flex-start;

  @media (max-width: 1100px) {
    width: auto;
  }
`;

const AircraftCardDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-start;
  padding: 24px;
  position: relative;
`;

const AircraftCardImage = styled.div`
  width: 100px;
  height: 70px;
  border-radius: 5px;
  overflow: hidden;
  background: #FFFFFF;
  flex-shrink: 0;
`;

const AircraftCardDetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`;

const AircraftCardDetailLabel = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  white-space: nowrap;
`;

const AircraftCardDetailValue = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #000000;
  letter-spacing: -0.14px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
`;

const AircraftCardDetailTimezone = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
  opacity: 0.5;
  letter-spacing: -0.14px;
  white-space: nowrap;
`;


const OrderRouteCharterCardMessages = defineMessages({
  mapTitle: {
    id: "orderRouteCharterCard.mapTitle",
    defaultMessage: "Map",
  },
  mapPopupTrip: {
    id: "orderRouteCharterCard.mapPopupTrip",
    defaultMessage: "Trip",
  },
  mapPopupDeparture: {
    id: "orderRouteCharterCard.mapPopupDeparture",
    defaultMessage: "Estimated departure time",
  },
  mapPopupArrival: {
    id: "orderRouteCharterCard.mapPopupArrival",
    defaultMessage: "Estimated arrival time",
  },
  showMap: {
    id: "orderRouteCharterCard.showMap",
    defaultMessage: "Show map",
  },
  approved: {
    id: "orderRouteCharterCard.approved",
    defaultMessage: "Offered",
  },
  waiting: {
    id: "orderRouteCharterCard.waiting",
    defaultMessage: "Waiting",
  },
  waitingCount: {
    id: "orderRouteCharterCard.waitingCount",
    defaultMessage: "{count} waiting",
  },
  pendingCount: {
    id: "orderRouteCharterCard.pendingCount",
    defaultMessage: "{count} pending",
  },
  declinedCount: {
    id: "orderRouteCharterCard.declinedCount",
    defaultMessage: "{count} declined",
  },
  cancelledCount: {
    id: "orderRouteCharterCard.cancelledCount",
    defaultMessage: "{count} cancelled",
  },
  jetsRequested: {
    id: "orderRouteCharterCard.jetsRequested",
    defaultMessage: "Jets requested",
  },
  aircraftOptions: {
    id: "orderRouteCharterCard.aircraftOptions",
    defaultMessage: "Варианты самолетов",
  },
  availabilityPeriod: {
    id: "orderRouteCharterCard.availabilityPeriod",
    defaultMessage: "Период доступности",
  },
  departTime: {
    id: "orderRouteCharterCard.departTime",
    defaultMessage: "Depart time",
  },
  arrivalTime: {
    id: "orderRouteCharterCard.arrivalTime",
    defaultMessage: "Время прибытия",
  },
  positioning: {
    id: "orderRouteCharterCard.positioning",
    defaultMessage: "Positioning",
  },
  positioningDistance: {
    id: "orderRouteCharterCard.positioningDistance",
    defaultMessage: "Расстояние позиционирования",
  },
  baseAirport: {
    id: "orderRouteCharterCard.baseAirport",
    defaultMessage: "Аэродром базирования",
  },
  aircraftCategory: {
    id: "orderRouteCharterCard.aircraftCategory",
    defaultMessage: "Категория самолета",
  },
  pax: {
    id: "orderRouteCharterCard.pax",
    defaultMessage: "PAX",
  },
  jets: {
    id: "orderRouteCharterCard.jets",
    defaultMessage: "Jets",
  },
  weekdaySun: {
    id: "orderRouteCharterCard.weekdaySun",
    defaultMessage: "Sun",
  },
  weekdayMon: {
    id: "orderRouteCharterCard.weekdayMon",
    defaultMessage: "Mon",
  },
  weekdayTue: {
    id: "orderRouteCharterCard.weekdayTue",
    defaultMessage: "Tue",
  },
  weekdayWed: {
    id: "orderRouteCharterCard.weekdayWed",
    defaultMessage: "Wed",
  },
  weekdayThu: {
    id: "orderRouteCharterCard.weekdayThu",
    defaultMessage: "Thu",
  },
  weekdayFri: {
    id: "orderRouteCharterCard.weekdayFri",
    defaultMessage: "Fri",
  },
  weekdaySat: {
    id: "orderRouteCharterCard.weekdaySat",
    defaultMessage: "Sat",
  },
  monthJan: {
    id: "orderRouteCharterCard.monthJan",
    defaultMessage: "Jan",
  },
  monthFeb: {
    id: "orderRouteCharterCard.monthFeb",
    defaultMessage: "Feb",
  },
  monthMar: {
    id: "orderRouteCharterCard.monthMar",
    defaultMessage: "Mar",
  },
  monthApr: {
    id: "orderRouteCharterCard.monthApr",
    defaultMessage: "Apr",
  },
  monthMay: {
    id: "orderRouteCharterCard.monthMay",
    defaultMessage: "May",
  },
  monthJun: {
    id: "orderRouteCharterCard.monthJun",
    defaultMessage: "Jun",
  },
  monthJul: {
    id: "orderRouteCharterCard.monthJul",
    defaultMessage: "Jul",
  },
  monthAug: {
    id: "orderRouteCharterCard.monthAug",
    defaultMessage: "Aug",
  },
  monthSep: {
    id: "orderRouteCharterCard.monthSep",
    defaultMessage: "Sep",
  },
  monthOct: {
    id: "orderRouteCharterCard.monthOct",
    defaultMessage: "Oct",
  },
  monthNov: {
    id: "orderRouteCharterCard.monthNov",
    defaultMessage: "Nov",
  },
  monthDec: {
    id: "orderRouteCharterCard.monthDec",
    defaultMessage: "Dec",
  },
  errorNoPlaneId: {
    id: "orderRouteCharterCard.errorNoPlaneId",
    defaultMessage: "Ошибка: не удалось определить ID самолета",
  },
  successAccepted: {
    id: "orderRouteCharterCard.successAccepted",
    defaultMessage: "Предложение самолета принято",
  },
  errorAcceptFailed: {
    id: "orderRouteCharterCard.errorAcceptFailed",
    defaultMessage: "Не удалось принять предложение",
  },
  successDeclined: {
    id: "orderRouteCharterCard.successDeclined",
    defaultMessage: "Предложение самолета отклонено",
  },
  errorDeclineFailed: {
    id: "orderRouteCharterCard.errorDeclineFailed",
    defaultMessage: "Не удалось отклонить предложение",
  },
  planeStatusOffered: {
    id: "orderRouteCharterCard.planeStatusOffered",
    defaultMessage: "Предложено",
  },
  planeStatusDeclined: {
    id: "orderRouteCharterCard.planeStatusDeclined",
    defaultMessage: "Отклонено",
  },
  planeStatusApproved: {
    id: "orderRouteCharterCard.planeStatusApproved",
    defaultMessage: "Одобрено",
  },
  planeStatusPending: {
    id: "orderRouteCharterCard.planeStatusPending",
    defaultMessage: "Ожидание",
  },
  lastModified: {
    id: "orderRouteCharterCard.lastModified",
    defaultMessage: "Изменено",
  },
  confirmAcceptMessage: {
    id: "orderRouteCharterCard.confirmAcceptMessage",
    defaultMessage: "Please confirm that you agreed on flight terms with operator and will book this aircraft.",
  },
  confirmDeclineMessage: {
    id: "orderRouteCharterCard.confirmDeclineMessage",
    defaultMessage: "Are you sure you want to decline this aircraft request?",
  },
  confirmDeclineAllMessage: {
    id: "orderRouteCharterCard.confirmDeclineAllMessage",
    defaultMessage: "Are you sure you want to decline and archive this request?",
  },
  noOrderRequestsToDecline: {
    id: "orderRouteCharterCard.noOrderRequestsToDecline",
    defaultMessage: "No offers to decline",
  },
  successDeclinedAndArchived: {
    id: "orderRouteCharterCard.successDeclinedAndArchived",
    defaultMessage: "Request has been declined and archived",
  },
})

interface IOrderRouteCharterCard {
  order: IChartererOrder;
}

interface IAircraftOptionCard {
  order: IChartererOrder;
  orderRequest: IChartererOrderRequestFromOrder;
  orderRequestPlane: IOrderRequestPlane;
}

const AircraftOptionCard: FC<IAircraftOptionCard> = ({order, orderRequest, orderRequestPlane}) => {
  const intl = useIntl();
  const offset = useUserTimezoneOffset();
  const dispatch = useAppDispatch();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isChatOpened, setIsChatOpened] = useState(false);
  const [isPlaneInfoDrawerOpen, setIsPlaneInfoDrawerOpen] = useState(false);
  
  // Используем orderRequestStatusId из orderRequestPlane для определения статуса
  const planeStatus = orderRequestPlane.orderRequestStatusId as OrderRequestPlaneStatusEnum | undefined;
  const planeStatusName = planeStatus === OrderRequestPlaneStatusEnum.STATUS_OFFERED_BY_OPERATOR 
    ? intl.formatMessage(OrderRouteCharterCardMessages.planeStatusOffered)
    : planeStatus === OrderRequestPlaneStatusEnum.STATUS_DECLINED_BY_OPERATOR
    ? intl.formatMessage(OrderRouteCharterCardMessages.planeStatusDeclined)
    : planeStatus === OrderRequestPlaneStatusEnum.STATUS_DECLINED_BY_BROKER
    ? intl.formatMessage(OrderRouteCharterCardMessages.planeStatusDeclined)
    : planeStatus === OrderRequestPlaneStatusEnum.STATUS_APPROVED_BY_BROKER
    ? intl.formatMessage(OrderRouteCharterCardMessages.planeStatusApproved)
    : intl.formatMessage(OrderRouteCharterCardMessages.planeStatusPending);
  
  const userId = useAppSelector(state => state.user.oneItemObject.item.id);
  const chat = useAircraftChat(userId, orderRequest.freighterUser.id, order.id);
  
  const unreadChatNotifications = useAppSelector(state => 
    state.notifications.unreadOnlyNotifications.filter(n => 
      n.entityId === chat?.chatId && 
      n.metadata.orderId === order.id &&
      n.metadata.orderRequestId === orderRequest.orderRequestId
    )
  );

  const handleChatClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsChatOpened(true);
  };

  const handleAccept = async () => {
    if (!orderRequestPlane.orderRequestPlaneId) {
      antdMessage.error(intl.formatMessage(OrderRouteCharterCardMessages.errorNoPlaneId));
      return;
    }

    const confirmMessage = intl.formatMessage(OrderRouteCharterCardMessages.confirmAcceptMessage);
    
    RenderConfirmModal(confirmMessage, async () => {
    try {
      const req = new BookingApiBrokerAcceptPlaneRequest()
        .setOrderrequestplaneid(orderRequestPlane.orderRequestPlaneId);

      const response = await BookingApi.brokerAcceptPlane(req);

      if (response.getResultresponse()?.getIssuccessful()) {
        // Немедленно обновляем статус в store
        dispatch(updateOrderRequestPlaneStatus({
          orderId: order.id,
          orderRequestId: orderRequest.orderRequestId,
          orderRequestPlaneId: orderRequestPlane.orderRequestPlaneId!,
          status: OrderRequestPlaneStatusEnum.STATUS_APPROVED_BY_BROKER,
        }));
          antdMessage.success(intl.formatMessage(OrderRouteCharterCardMessages.successAccepted));
        // Обновляем список заказов для синхронизации с сервером
        dispatch(getChartererOrderList({
          page: 1,
          types: [],
          showArchived: false,
        }));
      } else {
          const errorMessage = response.getResultresponse()?.getErrormessage() || response.getErrormessage() || intl.formatMessage(OrderRouteCharterCardMessages.errorAcceptFailed);
        antdMessage.error(errorMessage);
      }
    } catch (error) {
      Logger.error(`Failed to accept plane: ${error}`);
        antdMessage.error(intl.formatMessage(OrderRouteCharterCardMessages.errorAcceptFailed));
    }
    }, intl);
  };

  const handleDecline = async () => {
    if (!orderRequestPlane.orderRequestPlaneId) {
      antdMessage.error(intl.formatMessage(OrderRouteCharterCardMessages.errorNoPlaneId));
      return;
    }

    const confirmMessage = intl.formatMessage(OrderRouteCharterCardMessages.confirmDeclineMessage);
    
    RenderConfirmModal(confirmMessage, async () => {
    try {
      const req = new BookingApiBrokerDeclinePlaneRequest()
        .setOrderrequestplaneid(orderRequestPlane.orderRequestPlaneId);

      const response = await BookingApi.brokerDeclinePlane(req);

      if (response.getResultresponse()?.getIssuccessful()) {
        // Немедленно обновляем статус в store
        dispatch(updateOrderRequestPlaneStatus({
          orderId: order.id,
          orderRequestId: orderRequest.orderRequestId,
          orderRequestPlaneId: orderRequestPlane.orderRequestPlaneId!,
          status: OrderRequestPlaneStatusEnum.STATUS_DECLINED_BY_BROKER,
        }));
          antdMessage.success(intl.formatMessage(OrderRouteCharterCardMessages.successDeclined));
        // Обновляем список заказов для синхронизации с сервером
        dispatch(getChartererOrderList({
          page: 1,
          types: [],
          showArchived: false,
        }));
      } else {
          const errorMessage = response.getResultresponse()?.getErrormessage() || response.getErrormessage() || intl.formatMessage(OrderRouteCharterCardMessages.errorDeclineFailed);
        antdMessage.error(errorMessage);
      }
    } catch (error) {
      Logger.error(`Failed to decline plane: ${error}`);
        antdMessage.error(intl.formatMessage(OrderRouteCharterCardMessages.errorDeclineFailed));
      }
    }, intl);
  };

  // Memoize route requests to avoid recalculating on every render
  const orderRouteOrderRequests = useMemo(
    () => orderRequest.orderRouteOrderRequests || [],
    [orderRequest.orderRouteOrderRequests]
  );
  
  const firstRouteRequest = useMemo(
    () => orderRouteOrderRequests.length > 0 ? orderRouteOrderRequests[0] : null,
    [orderRouteOrderRequests]
  );
  const lastRouteRequest = useMemo(
    () => orderRouteOrderRequests.length > 0 ? orderRouteOrderRequests[orderRouteOrderRequests.length - 1] : null,
    [orderRouteOrderRequests]
  );
  
  // Memoize timezone display string since offset doesn't change
  const timezoneDisplay = useMemo(() => formatTimezoneOffsetUTC(offset), [offset]);
  
  // Use the requested departure date from the order route (what the user requested)
  // Priority logic:
  // 1. If operator has responded: use operator's chosen availableFromDate
  // 2. If operator hasn't responded: use departureDate from planeList (adjusted departure time from schedule events)
  // 3. Fallback to orderRouteOrderRequest, then order.orderRoutes
  const departTime = useMemo(() => {
    // Check if operator has actually responded by checking the plane status
    // Only use availableFromDate if operator has responded (STATUS_OFFERED_BY_OPERATOR or STATUS_APPROVED_BY_BROKER)
    const hasOperatorResponded = planeStatus === OrderRequestPlaneStatusEnum.STATUS_OFFERED_BY_OPERATOR 
      || planeStatus === OrderRequestPlaneStatusEnum.STATUS_APPROVED_BY_BROKER;
    
    // First priority: use operator's chosen availableFromDate ONLY if operator has responded
    if (hasOperatorResponded) {
      const availableFromDateStr = orderRequestPlane.availableFromDate;
      if (availableFromDateStr && typeof availableFromDateStr === 'string' && availableFromDateStr.trim() !== '') {
        try {
          const parsedDate = parseStringAsUTCDate(availableFromDateStr);
          if (isValidDate(parsedDate)) {
            return parsedDate;
          }
        } catch (e) {
          // Silently fail and continue to next priority
        }
      }
    }
    
    // Second priority: use departureDate from planeList (adjusted departure time, can differ per plane)
    // This is used when operator hasn't responded yet (status is PENDING or operator hasn't offered)
    const departureDateStr = orderRequestPlane.departureDate;
    // Check if departureDate exists and is a valid non-empty string
    // This is the adjusted departure time from schedule events, should be used when operator hasn't responded
    if (departureDateStr !== undefined && departureDateStr !== null && departureDateStr !== '' && typeof departureDateStr === 'string' && departureDateStr.trim() !== '') {
      try {
        const parsedDate = parseStringAsUTCDate(departureDateStr);
        if (isValidDate(parsedDate)) {
          return parsedDate;
        }
      } catch (e) {
        // Silently fail and continue to next priority
      }
    }
    
    // Third priority: use departure date from orderRouteOrderRequest
    if (firstRouteRequest?.orderRoute?.departureDate) {
      return firstRouteRequest.orderRoute.departureDate;
    }
    
    // Fallback: use departure date from order.orderRoutes
    if (order.orderRoutes && order.orderRoutes.length > 0) {
      return order.orderRoutes[0].departureDate;
    }
    
    return null;
  }, [planeStatus, orderRequestPlane.availableFromDate, orderRequestPlane.departureDate, firstRouteRequest, order.orderRoutes]);
  
  // Calculate arrival date object (not formatted string yet) - memoized for performance
  // Priority order:
  // 1. If operator responded - use arrivalDate from orderRouteOrderRequest (stored dates)
  // 2. If not, use arrivalDate from orderRequestPlane.arrivalDate (backend-calculated from last leg)
  // 3. If not, calculate from last leg departure date + last leg flight time
  // 4. If not, return null (will show "No data")
  const arrivalDateObj = useMemo(() => {
    // Priority 1: If operator responded, use arrivalDate from orderRouteOrderRequest (stored dates)
    if (lastRouteRequest?.arrivalDate) {
      // arrivalDate is already a Date object, just validate it
      if (isValidDate(lastRouteRequest.arrivalDate)) {
        return lastRouteRequest.arrivalDate;
      }
    }
    
    // Priority 2: Use arrivalDate from orderRequestPlane (backend-calculated from last leg when operator hasn't responded)
    if (orderRequestPlane.arrivalDate) {
      try {
        const parsed = parseStringAsUTCDate(orderRequestPlane.arrivalDate);
        if (isValidDate(parsed)) {
          return parsed;
        }
      } catch (e) {
        // Fall through to calculation if parsing fails
      }
    }
    
    // Priority 3: When there are no stored dates, calculate from last leg departure date + last leg flight time
    if (order.orderRoutes && order.orderRoutes.length > 0) {
      const lastRoute = order.orderRoutes[order.orderRoutes.length - 1];
      
      // Calculate from last leg departure date + last leg flight time
      if (lastRoute.departureDate && lastRoute.flyDuration && lastRoute.flyDuration > 0) {
        return calculateArrivalDateFromDuration(
          new Date(lastRoute.departureDate),
          lastRoute.flyDuration,
          0
        );
      }
    }
    
    // Priority 4: No data available
    return null;
  }, [lastRouteRequest, orderRequestPlane.arrivalDate, order.orderRoutes]);
  
  // Format arrival time: show date if it differs from departure date, otherwise just time
  // Optimized date comparison using UTC date strings for efficiency
  const arrivalTime = useMemo(() => {
    if (!arrivalDateObj || !departTime) {
      return null;
    }
    
    // Compare dates (ignoring time) using UTC date strings for efficiency
    const departureDateStr = departTime.toISOString().split('T')[0];
    const arrivalDateStr = arrivalDateObj.toISOString().split('T')[0];
    
    // If dates differ, show date + time, otherwise just time
    if (departureDateStr !== arrivalDateStr) {
      return formatDate(arrivalDateObj, offset, "datetime");
    }
    
    return formatDate(arrivalDateObj, offset, "time");
  }, [arrivalDateObj, departTime, offset]);
  
  // Используем данные из orderRequestPlane
  const baseAirport = orderRequestPlane.plane?.baseAirport ? DisplayAirport(orderRequestPlane.plane.baseAirport, "location_and_name") : null;
  const aircraftCategory = orderRequestPlane.plane?.planeType?.planeCategory?.name || null;
  const planeTypeName = orderRequestPlane.plane?.planeType?.name || orderRequest.freighterCompany.name;
  
  // Используем цену из orderRequestPlane (operatorPrice или preliminaryPrice)
  // Преобразуем строку в число, если необходимо
  const priceString = orderRequestPlane.operatorPrice || orderRequestPlane.preliminaryPrice;
  const displayPrice = priceString ? (typeof priceString === 'string' ? parseFloat(priceString) : priceString) : orderRequest.price;
  
  // Определяем валюту для отображения:
  // - Если есть operatorPrice, используем operatorCurrency
  // - Если есть только preliminaryPrice, он приходит в базовой валюте
  const isOperatorPrice = !!orderRequestPlane.operatorPrice;
  const baseCurrency = getBaseCurrencyInfo();
  const baseCurrencyId = getBaseCurrencyId();
  
  // Для preliminaryPrice используем базовую валюту, для operatorPrice - operatorCurrency
  const displayCurrency = isOperatorPrice 
    ? (orderRequestPlane.operatorCurrency || orderRequest.currency)
    : (baseCurrency || orderRequestPlane.currency || orderRequest.currency);
  
  // Конвертация в валюту пользователя
  const userCurrency = useAppSelector(state => state.user.oneItemObject.item?.currency || state.company.oneItemObject.item?.currency);
  const {convertSync, isReady} = useCurrencyConverter();
  
  const priceInUserCurrency = useMemo(() => {
    if (!userCurrency || !isReady || !displayPrice || !displayCurrency || !baseCurrencyId) {
      return null;
    }
    
    // Если валюта совпадает, конвертация не нужна
    if (displayCurrency.id === userCurrency.id) {
      return null;
    }
    
    // Для preliminaryPrice конвертируем из базовой валюты
    // Для operatorPrice конвертируем из operatorCurrency
    const fromCurrencyId = isOperatorPrice 
      ? displayCurrency.id 
      : baseCurrencyId;
    
    return convertSync(displayPrice, fromCurrencyId, userCurrency.id);
  }, [displayPrice, displayCurrency, userCurrency, convertSync, isReady, isOperatorPrice, baseCurrencyId]);

  // Calculate price in plane's currency if it differs from display currency
  const planeCurrency = orderRequestPlane.plane?.flyHourCurrency;
  const priceInPlaneCurrency = useMemo(() => {
    if (!planeCurrency || !isReady || !displayPrice || !displayCurrency || !baseCurrencyId) {
      return null;
    }
    
    // If plane's currency matches display currency, no conversion needed
    if (planeCurrency.id === displayCurrency.id) {
      return null;
    }
    
    // Convert from display currency to plane's currency
    try {
      const fromCurrencyId = isOperatorPrice 
        ? displayCurrency.id 
        : baseCurrencyId;
      
      const converted = convertSync(displayPrice, fromCurrencyId, planeCurrency.id);
      return Math.round(converted * 100) / 100;
    } catch (error) {
      console.error('[AircraftOptionCard] Failed to convert to plane currency:', error);
      return null;
    }
  }, [displayPrice, displayCurrency, planeCurrency, convertSync, isReady, isOperatorPrice, baseCurrencyId]);

  // Check if any other aircraft in the order has been approved by the broker
  // If yes, disable accept buttons on all other aircraft
  const hasOtherApprovedAircraft = useMemo(() => {
    // Check all order requests in the order
    for (const orderRequest of order.nestedOrderRequests) {
      // Check planeList first (new structure)
      if (orderRequest.planeList && orderRequest.planeList.length > 0) {
        for (const plane of orderRequest.planeList) {
          // Skip the current aircraft
          if (plane.orderRequestPlaneId === orderRequestPlane.orderRequestPlaneId) {
            continue;
          }
          // Check if this aircraft is approved
          if (plane.orderRequestStatusId === OrderRequestPlaneStatusEnum.STATUS_APPROVED_BY_BROKER) {
            return true;
          }
        }
      }
      // Note: Old structure (without planeList) doesn't have granular status tracking
      // so we can't reliably check for approved status in that case
    }
    return false;
  }, [order.nestedOrderRequests, orderRequestPlane.orderRequestPlaneId]);

  // Determine if accept button should be shown
  // Hide accept button if:
  // 1. Current aircraft is not offered by operator, OR
  // 2. Another aircraft is already approved (and current one is not the approved one)
  const canShowAcceptButton = planeStatus === OrderRequestPlaneStatusEnum.STATUS_OFFERED_BY_OPERATOR 
    && !hasOtherApprovedAircraft
    && orderRequestPlane.orderRequestPlaneId;

  return (
    <>
      <AircraftOptionsCard>
        <AircraftCardHeader>
          <AircraftCardHeaderLeft>
            <AircraftCardHeaderLeftBlock>
              <AircraftCardNameBlock>
                <AircraftCardName onClick={() => orderRequestPlane.plane && setIsPlaneInfoDrawerOpen(true)}>
                  {planeTypeName}, {aircraftCategory || <span style={{opacity: 0.5}}>{intl.formatMessage(CommonFormMessages.noData)}</span>}
                </AircraftCardName>
                <AircraftCardDottedLine />
              </AircraftCardNameBlock>
            </AircraftCardHeaderLeftBlock>
            <AircraftCardCompany>
              <AircraftCardCompanyName>
                <AircraftChatButton hasNewMessages={unreadChatNotifications.length > 0} onClick={handleChatClick} />
                <AircraftCardCompanyText>{orderRequest.freighterCompany.name}</AircraftCardCompanyText>
              </AircraftCardCompanyName>
            </AircraftCardCompany>
          </AircraftCardHeaderLeft>

          <AircraftCardHeaderRight>
            <AircraftCardPriceBlock>
              <AircraftCardPriceContainer>
              <AircraftCardPrice>
                  {priceInUserCurrency && userCurrency ? (
                    <>
                      <AircraftCardPriceMain>
                        {DisplayFlyPrice(priceInUserCurrency, userCurrency, intl.formatMessage(CommonDetailsMessages.onRequest))}
                      </AircraftCardPriceMain>
                      {displayCurrency.id !== userCurrency.id && (
                        <AircraftCardPriceSecondary>
                          {DisplayFlyPrice(displayPrice, displayCurrency)}
                        </AircraftCardPriceSecondary>
                      )}
                      {priceInPlaneCurrency && planeCurrency && planeCurrency.id !== displayCurrency.id && planeCurrency.id !== userCurrency.id && (
                        <AircraftCardPriceSecondary>
                          {DisplayFlyPrice(priceInPlaneCurrency, planeCurrency)}
                        </AircraftCardPriceSecondary>
                      )}
                    </>
                  ) : (
                    <>
                      <AircraftCardPriceMain>
                {DisplayFlyPrice(displayPrice, displayCurrency, intl.formatMessage(CommonDetailsMessages.onRequest))}
                      </AircraftCardPriceMain>
                      {priceInPlaneCurrency && planeCurrency && planeCurrency.id !== displayCurrency.id && (
                        <AircraftCardPriceSecondary>
                          {DisplayFlyPrice(priceInPlaneCurrency, planeCurrency)}
                        </AircraftCardPriceSecondary>
                      )}
                    </>
                  )}
              </AircraftCardPrice>
              {displayPrice && displayCurrency && (
                <InfoIconWrapper>
                  <InfoIcon />
                </InfoIconWrapper>
              )}
              </AircraftCardPriceContainer>
            </AircraftCardPriceBlock>

            <AircraftCardStatusBlock>
              <AircraftCardStatusBadge $status={planeStatus}>
                <AircraftCardStatusText>{planeStatusName}</AircraftCardStatusText>
              </AircraftCardStatusBadge>
              <AircraftCardActions>
                {canShowAcceptButton && (
                  <AcceptButton
                    active={false}
                    onClick={handleAccept}
                  />
                )}
                {(planeStatus === OrderRequestPlaneStatusEnum.STATUS_OFFERED_BY_OPERATOR || planeStatus === OrderRequestPlaneStatusEnum.STATUS_PENDING) && orderRequestPlane.orderRequestPlaneId && (
                  <DeclineButton
                    active={false}
                    onClick={handleDecline}
                  />
                )}
              </AircraftCardActions>
            </AircraftCardStatusBlock>
          </AircraftCardHeaderRight>
        </AircraftCardHeader>

        <AircraftCardDetails>
          <AircraftCardImage>
            <PlaneImage files={orderRequestPlane.plane?.imageFiles || []} width="100px" height="70px" />
          </AircraftCardImage>

          <AircraftCardDetailItem>
            <AircraftCardDetailLabel>
              {intl.formatMessage(OrderRouteCharterCardMessages.departTime)}
            </AircraftCardDetailLabel>
                <AircraftCardDetailValue>
              {departTime ? (
                <>
                  {formatDate(departTime, offset, "datetime")}
                  <AircraftCardDetailTimezone>
                    {timezoneDisplay}
                  </AircraftCardDetailTimezone>
                </>
              ) : (
                <span style={{opacity: 0.5}}>{intl.formatMessage(CommonFormMessages.noData)}</span>
              )}
            </AircraftCardDetailValue>
          </AircraftCardDetailItem>

          <AircraftCardDetailItem>
            <AircraftCardDetailLabel>
              {intl.formatMessage(OrderRouteCharterCardMessages.arrivalTime)}
            </AircraftCardDetailLabel>
            <AircraftCardDetailValue>
              {arrivalTime ? (
                <>
                  {arrivalTime}
                  <AircraftCardDetailTimezone>
                    {timezoneDisplay}
                  </AircraftCardDetailTimezone>
                </>
              ) : (
                <span style={{opacity: 0.5}}>{intl.formatMessage(CommonFormMessages.noData)}</span>
              )}
            </AircraftCardDetailValue>
          </AircraftCardDetailItem>

          {orderRequestPlane.positioningDurationMinutes !== undefined && orderRequestPlane.positioningDurationMinutes > 0 && (
          <AircraftCardDetailItem>
            <AircraftCardDetailLabel>
                {intl.formatMessage(OrderRouteCharterCardMessages.positioning)}
            </AircraftCardDetailLabel>
            <AircraftCardDetailValue>
                {`${Math.floor(orderRequestPlane.positioningDurationMinutes / 60)}:${String(orderRequestPlane.positioningDurationMinutes % 60).padStart(2, '0')}`}
                {orderRequestPlane.plane?.baseAirport && (
                  <> {DisplayAirport(orderRequestPlane.plane.baseAirport, "oneCode")}</>
                )}
            </AircraftCardDetailValue>
          </AircraftCardDetailItem>
          )}


          <AircraftCardDetailItem>
            <AircraftCardDetailLabel>
              {intl.formatMessage(OrderRouteCharterCardMessages.baseAirport)}
            </AircraftCardDetailLabel>
            <AircraftCardDetailValue>
              {baseAirport || <span style={{opacity: 0.5}}>{intl.formatMessage(CommonFormMessages.noData)}</span>}
            </AircraftCardDetailValue>
          </AircraftCardDetailItem>

        </AircraftCardDetails>
      </AircraftOptionsCard>

      {isDrawerOpen && (
        <OrderOrderRequestFlightDrawer 
          isOpen={isDrawerOpen} 
          setIsOpen={setIsDrawerOpen}
          order={order} 
          orderRequest={orderRequest}
          openChat={() => setIsChatOpened(true)} 
        />
      )}

      {isChatOpened && chat && (
        <AircraftChatModal 
          chat={chat}
          isVisible={isChatOpened}
          setIsVisible={setIsChatOpened}
        />
      )}

      {orderRequestPlane.plane && (
        <CustomDrawer
          open={isPlaneInfoDrawerOpen}
          onClose={() => setIsPlaneInfoDrawerOpen(false)}
          placement="right"
          width={600}
        >
          <FlightDrawerPhotosAndContentWrapper>
            {orderRequestPlane.plane.imageFiles && orderRequestPlane.plane.imageFiles.length > 0 && (
              <PlanePhotos imageFiles={orderRequestPlane.plane.imageFiles} />
            )}

            <FlightDrawerContentWrapper>
              <FlightDrawerPlane plane={orderRequestPlane.plane} />
            </FlightDrawerContentWrapper>
          </FlightDrawerPhotosAndContentWrapper>
        </CustomDrawer>
      )}
    </>
  );
};

export const OrderCharterCard: FC<IOrderRouteCharterCard> = ({order}) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const offset = useUserTimezoneOffset();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [isPastResponsesModalOpen, setIsPastResponsesModalOpen] = useState<boolean>(false);
  const [isMapModalOpen, setIsMapModalOpen] = useState<boolean>(false);
  const userId = useAppSelector(state => state.user.oneItemObject.item.id);
  const [isChatOpened, setIsChatOpened] = useState<boolean>(false);
  const [isFavorite, setIsFavorite] = useState<boolean>(order.isFavorite);
  const [charterOfferStatusesInfo, setCharterOfferStatusesInfo] = useState<ICharterOfferStatusesInfo>(defaultCharterOfferStatusesInfo);
  const archiveHandledRef = React.useRef<boolean>(false);
  
  const {
    isLoading: isDeclineLoading,
    isSuccess: isDeclineSuccess,
    errorMessage: declineErrorMessage,
  } = useAppSelector(state => state.freighterRequests.changeOrderRequestWithdraw);
  
  const {
    isLoading: isArchiveLoading,
    isSuccess: isArchiveSuccess,
    errorMessage: archiveErrorMessage,
  } = useAppSelector(state => state.chartererRequests.delete);

  const hasUnreadNotifications = useAppSelector(state => state.notifications.unreadOnlyNotifications)
    .some(n => n.metadata.orderId === order.id)

  useEffect(() => {
    setIsFavorite(order.isFavorite);
  }, [order.isFavorite]);

  useEffect(() => {
    // Подсчитываем статусы самолетов из planeList, а не статусы заявок
    let offeredCount = 0; // STATUS_OFFERED_BY_OPERATOR (operator responded)
    let pendingCount = 0; // STATUS_PENDING (waiting for operator response)
    let declinedCount = 0; // STATUS_DECLINED_BY_BROKER or STATUS_DECLINED_BY_OPERATOR

    order.nestedOrderRequests.forEach(orderRequest => {
      if (orderRequest.planeList && orderRequest.planeList.length > 0) {
        orderRequest.planeList.forEach(plane => {
          const status = plane.orderRequestStatusId as OrderRequestPlaneStatusEnum | undefined;
          if (status === OrderRequestPlaneStatusEnum.STATUS_OFFERED_BY_OPERATOR) {
            offeredCount++;
          } else if (status === OrderRequestPlaneStatusEnum.STATUS_PENDING) {
            pendingCount++;
          } else if (status === OrderRequestPlaneStatusEnum.STATUS_DECLINED_BY_BROKER || status === OrderRequestPlaneStatusEnum.STATUS_DECLINED_BY_OPERATOR) {
            declinedCount++;
          }
          // Note: STATUS_APPROVED_BY_BROKER is not counted separately - it's considered as offered
          else if (status === OrderRequestPlaneStatusEnum.STATUS_APPROVED_BY_BROKER) {
            offeredCount++;
          }
        });
      } else {
        // Если planeList нет, используем старую логику со статусом заявки
        if (orderRequest.status === OrderRequestStatusEnum.OFFERED) {
          offeredCount++;
        } else if (orderRequest.status === OrderRequestStatusEnum.NOT_OFFERED) {
          pendingCount++;
        } else if (orderRequest.status === OrderRequestStatusEnum.DECLINED) {
          declinedCount++;
        }
      }
    });

    setCharterOfferStatusesInfo({
      offered: offeredCount,
      notOffered: pendingCount,
      declined: declinedCount,
    });
  }, [order.nestedOrderRequests])

  // Get route information
  const firstRoute = order.orderRoutes[0];
  const lastRoute = order.orderRoutes[order.orderRoutes.length - 1];
  const isOnlyRoute = firstRoute.id === lastRoute.id;

  // Calculate minimal departure time across all aircraft for closed card display
  // This ensures we show the earliest departure time when multiple aircraft have different times
  const minimalDepartureDate = useMemo(() => {
    const allDepartureDates: Date[] = [];
    
    order.nestedOrderRequests.forEach(orderRequest => {
      // Check planeList first (new structure) - use departureDate from planeList
      if (orderRequest.planeList && orderRequest.planeList.length > 0) {
        orderRequest.planeList.forEach(plane => {
          // Priority: use departureDate from planeList (adjusted departure time)
          if (plane.departureDate) {
            const parsedDate = parseStringAsUTCDate(plane.departureDate);
            if (isValidDate(parsedDate)) {
              allDepartureDates.push(parsedDate);
              return; // Skip to next plane
            }
          }
          // Fallback: try orderRouteOrderRequests
          if (orderRequest.orderRouteOrderRequests && orderRequest.orderRouteOrderRequests.length > 0) {
            const firstRouteRequest = orderRequest.orderRouteOrderRequests[0];
            if (firstRouteRequest?.orderRoute?.departureDate) {
              allDepartureDates.push(firstRouteRequest.orderRoute.departureDate);
            }
          }
        });
      } else {
        // Fallback to orderRouteOrderRequests if planeList is not available
        if (orderRequest.orderRouteOrderRequests && orderRequest.orderRouteOrderRequests.length > 0) {
          const firstRouteRequest = orderRequest.orderRouteOrderRequests[0];
          if (firstRouteRequest?.orderRoute?.departureDate) {
            allDepartureDates.push(firstRouteRequest.orderRoute.departureDate);
          }
        }
      }
    });
    
    // If no aircraft-specific departure times found, fall back to order routes
    if (allDepartureDates.length === 0 && order.orderRoutes.length > 0) {
      allDepartureDates.push(order.orderRoutes[0].departureDate);
    }
    
    // Return the earliest (minimal) departure time
    if (allDepartureDates.length > 0) {
      return allDepartureDates.reduce((min, date) => 
        date.getTime() < min.getTime() ? date : min
      );
    }
    
    return firstRoute.departureDate;
  }, [order.nestedOrderRequests, order.orderRoutes, firstRoute]);

  const allOrderAirports: IAirport[] = useMemo(() => order.orderRoutes.reduce((acc, cur, index) => {
    if (index === 0)
      acc.push(cur.airportFrom);
    acc.push(cur.airportTo);
    return acc;
  }, [] as IAirport[]), [order.orderRoutes]);

  // For multileg routes, prepare all airports for display
  // Show only 2 airports and then "(+count)" for the rest
  const routeAirportsDisplay = useMemo(() => {
    return allOrderAirports.map(airport => DisplayAirport(airport, "codes"));
  }, [allOrderAirports]);

  const firstSliceCount = 2; // Show 2 airports for both mobile and desktop
  const airportsToDisplay = routeAirportsDisplay.slice(0, firstSliceCount);
  const moreAirportsCount = routeAirportsDisplay.length - firstSliceCount;

  // Calculate PAX (use max from routes)
  const pax = Math.max(...order.orderRoutes.map(r => r.pax), 0);

  // Get requested departure time from first route for expanded view itinerary
  // Use the requested time (orderRoute.departureDate contains requested_start from backend)
  const itineraryDepartureDate = useMemo(() => {
    // Use the requested departure time from the first route
    return firstRoute.departureDate;
  }, [firstRoute]);

  // Get Jets status
  const offeredCount = charterOfferStatusesInfo.offered; // Jets offered by operator
  const pendingCount = charterOfferStatusesInfo.notOffered; // Jets pending (waiting for operator)
  const declinedCount = charterOfferStatusesInfo.declined; // Jets declined
  // Use real data from backend
  const totalJets = order.nestedOrderRequests.length;
  const hasOfferedJets = offeredCount > 0; // Has any jets offered by operator
  const hasUnreadJetsNotifications = hasUnreadNotifications && hasOfferedJets;

  // Calculate last modified date from all order requests
  const lastModifiedDate = useMemo(() => {
    const dates: Date[] = [];
    order.nestedOrderRequests.forEach(orderRequest => {
      if (orderRequest.updatedAtDate) {
        dates.push(orderRequest.updatedAtDate);
      }
    });
    if (dates.length > 0) {
      const maxDate = new Date(Math.max(...dates.map(d => d.getTime())));
      // Only show if it's different from created date (more than 1 minute difference)
      const timeDiff = Math.abs(maxDate.getTime() - order.createdDate.getTime());
      if (timeDiff > 60000) { // 1 minute in milliseconds
        return maxDate;
      }
    }
    return null;
  }, [order.nestedOrderRequests, order.createdDate]);

  // Get chat for the first order request if exists, otherwise use order's user (for general chat)
  const firstOrderRequest = useMemo(() => order.nestedOrderRequests[0], [order.nestedOrderRequests]);
  const chatUserId = useMemo(() => firstOrderRequest?.freighterUser.id || order.user.id, [firstOrderRequest, order.user.id]);
  const chat = useChat(userId, chatUserId, order.id);

  const unreadChatNotifications = useAppSelector(state => 
    state.notifications.unreadOnlyNotifications.filter(n => 
      n.entityId === chat?.chatId && 
      n.metadata.orderId === order.id &&
      (!n.metadata.orderRequestId || n.metadata.orderRequestId === firstOrderRequest?.orderRequestId)
    )
  );

  const handleChatClick = () => {
    setIsChatOpened(true);
  };

  const handleShowMap = () => {
    setIsMapModalOpen(true);
  };

  const routeAirports = useMemo(() => {
    const airports = [
      order.orderRoutes[0]?.airportFrom,
      ...order.orderRoutes.map(route => route.airportTo),
    ];
    return airports.filter(Boolean) as IAirport[];
  }, [order.orderRoutes]);

  const routeLatLngs = useMemo(() => {
    const raw = routeAirports
      .map((airport) => {
        const lat = airport.latitude ? parseFloat(airport.latitude) : NaN;
        const lng = airport.longitude ? parseFloat(airport.longitude) : NaN;
        return (Number.isFinite(lat) && Number.isFinite(lng)) ? [lat, lng] as LatLngTuple : null;
      })
      .filter((point): point is LatLngTuple => !!point);

    if (raw.length === 0) {
      return [];
    }

    const unwrapped: LatLngTuple[] = [raw[0]];
    for (let i = 1; i < raw.length; i += 1) {
      const [lat, lon] = raw[i];
      const prevLon = unwrapped[i - 1][1];
      let nextLon = lon;
      const delta = nextLon - prevLon;
      if (delta > 180) {
        nextLon -= 360;
      } else if (delta < -180) {
        nextLon += 360;
      }
      unwrapped.push([lat, nextLon]);
    }
    return unwrapped;
  }, [routeAirports]);

  const [mapModalContentEl, setMapModalContentEl] = useState<HTMLDivElement | null>(null);

  const approvedPlane = useMemo(() => {
    for (const orderRequest of order.nestedOrderRequests) {
      const plane = orderRequest.planeList?.find(
        (item) => item.orderRequestStatusId === OrderRequestPlaneStatusEnum.STATUS_APPROVED_BY_BROKER
      );
      if (plane) {
        return plane as IOrderRequestPlane;
      }
    }
    return null;
  }, [order.nestedOrderRequests]);

  const planeProgress = useMemo(() => {
    if (!approvedPlane) return null;
    if (!order.orderRoutes.length) return null;
    if (routeLatLngs.length !== order.orderRoutes.length + 1) return null;

    const segments = order.orderRoutes.map((route) => {
      if (!route.departureDate) return null;
      const departure = new Date(route.departureDate as unknown as string);
      if (!isValidDate(departure)) return null;
      const durationMinutes = Number(route.flyDuration);
      if (!Number.isFinite(durationMinutes) || durationMinutes <= 0) return null;
      const end = new Date(departure.getTime() + durationMinutes * 60000);
      return {start: departure, end};
    });

    if (segments.some((segment) => !segment)) return null;
    const typedSegments = segments as Array<{start: Date; end: Date}>;
    const now = new Date();

    if (now < typedSegments[0].start) {
      return {segmentIndex: 0, progress: 0};
    }
    if (now > typedSegments[typedSegments.length - 1].end) {
      return {segmentIndex: typedSegments.length - 1, progress: 1};
    }

    const segmentIndex = typedSegments.findIndex((segment) => now >= segment.start && now <= segment.end);
    if (segmentIndex === -1) return null;

    const duration = typedSegments[segmentIndex].end.getTime() - typedSegments[segmentIndex].start.getTime();
    if (duration <= 0) return null;
    const rawProgress = (now.getTime() - typedSegments[segmentIndex].start.getTime()) / duration;
    return {segmentIndex, progress: Math.min(1, Math.max(0, rawProgress))};
  }, [approvedPlane, order.orderRoutes, routeLatLngs]);

  const popupSegments = useMemo(() => {
    return order.orderRoutes.map((route) => {
      if (!route.airportFrom || !route.airportTo) return null;
      const from = DisplayAirport(route.airportFrom, "codes");
      const to = DisplayAirport(route.airportTo, "codes");
      if (!from || !to) return null;

      let departureText: string | null = null;
      let arrivalText: string | null = null;

      if (route.departureDate) {
        const departure = new Date(route.departureDate as unknown as string);
        if (isValidDate(departure)) {
          departureText = formatDate(departure, offset, "datetime");
          const arrival = calculateArrivalDateFromDuration(departure, route.flyDuration, 0);
          if (arrival && isValidDate(arrival)) {
            arrivalText = formatDate(arrival, offset, "datetime");
          }
        }
      }

      return {
        from,
        to,
        departure: departureText,
        arrival: arrivalText,
      };
    });
  }, [order.orderRoutes, offset]);

  const markerRadius = 5;

  const handleDocumentSearch = () => {
    setIsPastResponsesModalOpen(true);
  };

  const handleFlag = () => {
    const newFavoriteState = !isFavorite;
    setIsFavorite(newFavoriteState);
    dispatch(updateOrderFavorite({
      orderId: order.id,
      isFavorite: newFavoriteState,
    }));
  };

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleDeclineAllOrderRequests = () => {
    const confirmMessage = intl.formatMessage(OrderRouteCharterCardMessages.confirmDeclineAllMessage);
    
    RenderConfirmModal(confirmMessage, async () => {
      // Archive the order - backend will automatically decline all order requests
      dispatch(archiveOrder({itemId: order.id}));
    }, intl);
  };

  useEffect(() => {
    if (!isDeclineLoading) {
      if (isDeclineSuccess) {
        dispatch(clearChangeOrderRequestWithdraw());
      } else if (declineErrorMessage) {
        antdMessage.error(declineErrorMessage);
        dispatch(clearChangeOrderRequestWithdraw());
      }
    }
  }, [isDeclineLoading, isDeclineSuccess, declineErrorMessage, intl, dispatch]);

  // Clear archive state on mount to prevent showing messages on page reload
  useEffect(() => {
    if (isArchiveSuccess && !isArchiveLoading) {
      dispatch(clearArchiveOrder());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isArchiveLoading && isArchiveSuccess && !archiveHandledRef.current && order.isArchived) {
      // Only show message if order is actually archived and we haven't handled it yet
      archiveHandledRef.current = true;
      antdMessage.success(intl.formatMessage(OrderRouteCharterCardMessages.successDeclinedAndArchived || {
        id: "orderRouteCharterCard.successDeclinedAndArchived",
        defaultMessage: "Request has been declined and archived"
      }));
      // Refresh the order list to reflect the changes (only once)
      dispatch(getChartererOrderList({
        page: 1,
        types: [],
        showArchived: false,
      }));
      // Refresh tab counters
      dispatch(getOrderListCounts({
        types: [],
      }));
      dispatch(clearArchiveOrder());
    } else if (!isArchiveLoading && archiveErrorMessage && !archiveHandledRef.current) {
      archiveHandledRef.current = true;
      antdMessage.error(archiveErrorMessage);
      dispatch(clearArchiveOrder());
    }
    
    // Reset the ref when archive loading starts (new action)
    if (isArchiveLoading) {
      archiveHandledRef.current = false;
    }
  }, [isArchiveLoading, isArchiveSuccess, archiveErrorMessage, order.isArchived, intl, dispatch]);

  // Memoize timezone display string since offset doesn't change
  const timezoneDisplay = useMemo(() => formatTimezoneOffsetUTC(offset), [offset]);
  
  const formatDateWithWeekday = (date: Date, timezoneOffset: number): string => {
    const adjustedDate = new Date(date.getTime() + timezoneOffset * 60000);
    const weekdays = [
      intl.formatMessage(OrderRouteCharterCardMessages.weekdaySun),
      intl.formatMessage(OrderRouteCharterCardMessages.weekdayMon),
      intl.formatMessage(OrderRouteCharterCardMessages.weekdayTue),
      intl.formatMessage(OrderRouteCharterCardMessages.weekdayWed),
      intl.formatMessage(OrderRouteCharterCardMessages.weekdayThu),
      intl.formatMessage(OrderRouteCharterCardMessages.weekdayFri),
      intl.formatMessage(OrderRouteCharterCardMessages.weekdaySat),
    ];
    const months = [
      intl.formatMessage(OrderRouteCharterCardMessages.monthJan),
      intl.formatMessage(OrderRouteCharterCardMessages.monthFeb),
      intl.formatMessage(OrderRouteCharterCardMessages.monthMar),
      intl.formatMessage(OrderRouteCharterCardMessages.monthApr),
      intl.formatMessage(OrderRouteCharterCardMessages.monthMay),
      intl.formatMessage(OrderRouteCharterCardMessages.monthJun),
      intl.formatMessage(OrderRouteCharterCardMessages.monthJul),
      intl.formatMessage(OrderRouteCharterCardMessages.monthAug),
      intl.formatMessage(OrderRouteCharterCardMessages.monthSep),
      intl.formatMessage(OrderRouteCharterCardMessages.monthOct),
      intl.formatMessage(OrderRouteCharterCardMessages.monthNov),
      intl.formatMessage(OrderRouteCharterCardMessages.monthDec),
    ];
    
    const weekday = weekdays[adjustedDate.getUTCDay()];
    const day = adjustedDate.getUTCDate();
    const month = months[adjustedDate.getUTCMonth()];
    const year = adjustedDate.getUTCFullYear();
    const hours = adjustedDate.getUTCHours().toString().padStart(2, '0');
    const minutes = adjustedDate.getUTCMinutes().toString().padStart(2, '0');
    
    return `${weekday}, ${day} ${month} ${year} (${hours}:${minutes} ${timezoneDisplay})`;
  };

  return (
    <OrderCardWrapper>
      <OrderCardHeader>
        <OrderCardMainRow>
          <BrokerInfoSection>
            <div>{formatDate(order.createdDate, offset, "datetime_short_year")}</div>
            <div>{DisplayFullName(order.user, "short")}</div>
            {lastModifiedDate && (
              <LastModifiedText>
                {intl.formatMessage(OrderRouteCharterCardMessages.lastModified)}: {formatDate(lastModifiedDate, offset, "datetime_short_year")}
              </LastModifiedText>
            )}
          </BrokerInfoSection>

          <OrderCardChatButton 
            hasNewMessages={unreadChatNotifications.length > 0} 
            onClick={handleChatClick}
          />

          <VerticalDividerStyled/>

          <OrderTypeSection>
            <OrderTypeShield type={order.type} styleType="outline"/>
          </OrderTypeSection>

          <LargeScreenVerticalDividerStyled/>

          <RouteSection>
            <RouteDate>
              {formatDate(minimalDepartureDate, offset, isOnlyRoute ? "datetime" : "date")}
              {!isOnlyRoute && ` – ${formatDate(lastRoute.departureDate, offset, "date")}`}
            </RouteDate>
            <RouteAirports>
              {airportsToDisplay.map((airport, index) => {
                if (index === 0) {
                  return <div key={index}>{airport}</div>;
                }
                return (
                  <React.Fragment key={index}>
              <RouteMiniArrowIcon/>
                    <div>{airport}</div>
                  </React.Fragment>
                );
              })}
              {moreAirportsCount > 0 && (
                <RouteAirportsMore onClick={handleExpand}>
                  (+{moreAirportsCount})
                </RouteAirportsMore>
              )}
            </RouteAirports>
            <ShowMapLink onClick={handleShowMap}>
              <MapIcon/>
              <div>{intl.formatMessage(OrderRouteCharterCardMessages.showMap)}</div>
            </ShowMapLink>
          </RouteSection>

          <VerticalDividerStyled/>

          <PaxSection>
            <div>{intl.formatMessage(OrderRouteCharterCardMessages.pax)}</div>
    <div>
              <PaxIcon/>
              <div>{pax}</div>
            </div>
          </PaxSection>

          <VerticalDividerStyled/>

          <JetsStatusSection>
            <JetsStatusLabel>{intl.formatMessage(OrderRouteCharterCardMessages.jets)}</JetsStatusLabel>
            <JetsStatusRow>
              <JetsStatusBadge isApproved={hasOfferedJets}>
                {hasOfferedJets ? offeredCount : pendingCount}
                {hasUnreadJetsNotifications && <JetsStatusDot/>}
              </JetsStatusBadge>
              <JetsStatusText>
                {hasOfferedJets 
                  ? intl.formatMessage(OrderRouteCharterCardMessages.approved)
                  : intl.formatMessage(OrderRouteCharterCardMessages.waiting)
                }
              </JetsStatusText>
            </JetsStatusRow>
            <JetsStatusDetails>
              {hasOfferedJets ? (
                <>
                  {/* Show pending and declined counts if any */}
                  {pendingCount > 0 && declinedCount > 0 && 
                    `${intl.formatMessage(OrderRouteCharterCardMessages.pendingCount, {count: pendingCount})}, ${intl.formatMessage(OrderRouteCharterCardMessages.declinedCount, {count: declinedCount})}`
                  }
                  {pendingCount > 0 && declinedCount === 0 && 
                    intl.formatMessage(OrderRouteCharterCardMessages.pendingCount, {count: pendingCount})
                  }
                  {pendingCount === 0 && declinedCount > 0 && 
                    intl.formatMessage(OrderRouteCharterCardMessages.declinedCount, {count: declinedCount})
                  }
                </>
              ) : (
                <>
                  {/* No offered jets - show declined if any */}
                  {declinedCount > 0 && 
                    intl.formatMessage(OrderRouteCharterCardMessages.declinedCount, {count: declinedCount})
                  }
                </>
              )}
            </JetsStatusDetails>
          </JetsStatusSection>

          <LargeScreenVerticalDividerStyled />

          <ActionsSection>
            <ActionButtonWrapper onClick={handleDocumentSearch} heightSize={'m'}>
              <DocumentSearchIcon/>
            </ActionButtonWrapper>
            <FavoriteButtonWrapper
              heightSize={'m'}
              $isFavorite={isFavorite}
              icon={
                isFavorite ? 
                  <FlagFilledIcon style={{color: "#1890FF"}}/> : 
                  <FlagIcon/>
              }
              onClick={handleFlag}
            />
            {!order.isArchived && order.nestedOrderRequests.length > 0 && order.nestedOrderRequests.some(
              (or: IChartererOrderRequestFromOrder) => or.status !== OrderRequestStatusEnum.DECLINED
            ) && (
              <CustomButton
                heightSize={'m'} 
                style={{
                  minWidth: 45, 
                  width: 45, 
                  height: 35, 
                  background: "#FAFAFA"
                }} 
                icon={<CloseIcon/>}
                onClick={handleDeclineAllOrderRequests}
              />
            )}
            <ExpandButtonWrapper onClick={handleExpand} $isExpanded={isExpanded}>
              <ExpandIcon/>
            </ExpandButtonWrapper>
          </ActionsSection>
        </OrderCardMainRow>
      </OrderCardHeader>

      {isExpanded && (
        <ExpandedSection>
          <ItineraryCard>
            <ItineraryContent>
              <ItineraryRouteSection>
                {order.orderRoutes.map((orderRoute, index) => (
                  <div key={orderRoute.id} style={{display: 'flex', gap: '0', alignItems: 'flex-start', width: '100%'}}>
                    
                    <PaxRequestedSection>
                      <PaxRequestedLabel>
                        {intl.formatMessage(OrderRouteCharterCardMessages.pax)}
                      </PaxRequestedLabel>
                      <PaxRequestedCount>{orderRoute.pax ?? 0}</PaxRequestedCount>
                    </PaxRequestedSection>
                    
                    <ItineraryVerticalDivider style={{width: '1px', height: '45px', margin: '0 30px'}}/>

                    <RouteFromToWrapper style={{flex: 1}}>
                  <RouteFromToItem>
                        
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                      <RouteAirportCode>
                            {DisplayAirport(orderRoute.airportFrom, "codes")}
                      </RouteAirportCode>
                      <RouteAirportLocation>
                            ({DisplayAirport(orderRoute.airportFrom, "location_and_name")})
                      </RouteAirportLocation>
                    </div>
                        <RouteFromToDate>
                          {index === 0 
                            ? formatDateWithWeekday(itineraryDepartureDate, offset)
                            : formatDateWithWeekday(orderRoute.departureDate, offset)
                          }
                        </RouteFromToDate>
                  </RouteFromToItem>

                  <RouteArrowWrapper>
                    <RouteArrowIcon/>
                  </RouteArrowWrapper>

                  <RouteFromToItem>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                      <RouteAirportCode>
                            {DisplayAirport(orderRoute.airportTo, "codes")}
                      </RouteAirportCode>
                      <RouteAirportLocation>
                            ({DisplayAirport(orderRoute.airportTo, "location_and_name")})
                      </RouteAirportLocation>
                    </div>
                  </RouteFromToItem>
                </RouteFromToWrapper>
                  </div>
                ))}
              </ItineraryRouteSection>
            </ItineraryContent>
          </ItineraryCard>

          <InfoCardsRow>
            <InfoCardLeft>
              <InfoCardLabel>{intl.formatMessage(CommonDetailsMessages.planeCategories)}</InfoCardLabel>
              <InfoCardValue>{DisplayPlaneCategories(order.planeCategories, intl)}</InfoCardValue>
            </InfoCardLeft>

            <InfoCardRight>
              <InfoCardLabel>{intl.formatMessage(CommonDetailsMessages.companionsAllowed)}</InfoCardLabel>
              <InfoCardValue>{DisplayYesOrNo(order.companionsAllowed, intl)}</InfoCardValue>
            </InfoCardRight>
          </InfoCardsRow>

          <AircraftOptionsSection>
            <AircraftOptionsTitle>{intl.formatMessage(OrderRouteCharterCardMessages.aircraftOptions)}: {totalJets}</AircraftOptionsTitle>
            {order.nestedOrderRequests.length > 0 ? (() => {
              // Собираем все самолеты вместе с их orderRequest в один массив
              const allAircrafts: Array<{orderRequest: IChartererOrderRequestFromOrder, orderRequestPlane: IOrderRequestPlane}> = [];
              
              order.nestedOrderRequests.forEach((orderRequest) => {
                // Используем planeList из orderRequest, если он есть, иначе используем старый способ с plane
                const planesToDisplay = orderRequest.planeList && orderRequest.planeList.length > 0
                  ? orderRequest.planeList
                  : orderRequest.plane && orderRequest.orderRequestPlaneId
                  ? [{
                      orderRequestPlaneId: orderRequest.orderRequestPlaneId,
                      orderRequestId: orderRequest.orderRequestId,
                      planeId: orderRequest.plane.id,
                      plane: orderRequest.plane,
                      orderRequestStatusId: orderRequest.status === OrderRequestStatusEnum.OFFERED 
                        ? OrderRequestPlaneStatusEnum.STATUS_OFFERED_BY_OPERATOR 
                        : OrderRequestPlaneStatusEnum.STATUS_PENDING,
                      operatorPrice: orderRequest.price.toString(),
                      operatorCurrencyId: orderRequest.currency.id,
                      currency: orderRequest.currency,
                    } as IOrderRequestPlane]
                  : [];

                planesToDisplay.forEach((orderRequestPlane) => {
                  allAircrafts.push({orderRequest, orderRequestPlane});
                });
              });

              // Сортируем все самолеты: сначала подтвержденные (STATUS_APPROVED_BY_BROKER), потом остальные
              const sortedAircrafts = allAircrafts.sort((a, b) => {
                const aIsApproved = a.orderRequestPlane.orderRequestStatusId === OrderRequestPlaneStatusEnum.STATUS_APPROVED_BY_BROKER;
                const bIsApproved = b.orderRequestPlane.orderRequestStatusId === OrderRequestPlaneStatusEnum.STATUS_APPROVED_BY_BROKER;
                if (aIsApproved && !bIsApproved) return -1;
                if (!aIsApproved && bIsApproved) return 1;
                return 0;
              });

              return sortedAircrafts.map(({orderRequest, orderRequestPlane}) => (
                  <AircraftOptionCard 
                    key={`${orderRequest.orderRequestId}-${orderRequestPlane.orderRequestPlaneId}`} 
                                                       order={order}
                    orderRequest={orderRequest}
                    orderRequestPlane={orderRequestPlane}
                  />
                ));
            })() : (
              <div>{intl.formatMessage(CommonFormMessages.noData)}</div>
            )}
          </AircraftOptionsSection>
        </ExpandedSection>
      )}

      {isChatOpened && chat && (
        <ChatModal 
          chat={chat}
          isVisible={isChatOpened}
          setIsVisible={setIsChatOpened}
        />
      )}

      <PastResponsesModal
        visible={isPastResponsesModalOpen}
        onClose={() => setIsPastResponsesModalOpen(false)}
        routeFrom={firstRoute.airportFrom}
        routeTo={lastRoute.airportTo}
        allRouteAirports={allOrderAirports}
        orderId={order.id}
      />

      <MapModal
        open={isMapModalOpen}
        onCancel={() => setIsMapModalOpen(false)}
        footer={null}
        width={950}
        centered
        destroyOnClose
      >
        <MapModalContent ref={setMapModalContentEl}>
          <MapModalHeader>
            <MapModalTitle>{intl.formatMessage(OrderRouteCharterCardMessages.mapTitle)}</MapModalTitle>
            <MapModalCloseButton onClick={() => setIsMapModalOpen(false)}>
              <CloseIcon />
            </MapModalCloseButton>
          </MapModalHeader>
          <MapModalBody>
            <MapModalRouteText>
              {(() => {
                return routeAirports.map(airport => DisplayAirport(airport, "codes")).join(" → ");
              })()}
            </MapModalRouteText>
            <MapWrapper>
              <MapInnerWrapper>
                <MapContainer
                  style={{width: "100%", height: "100%"}}
                  bounds={routeLatLngs.length ? latLngBounds(routeLatLngs) : undefined}
                  center={routeLatLngs[0] || [0, 0]}
                  zoom={routeLatLngs.length ? undefined : 2}
                  scrollWheelZoom
                >
                  <MapSizeUpdater isOpen={isMapModalOpen} hasRoute={routeLatLngs.length > 0} />
                  <TileLayer
                    attribution="&copy; OpenStreetMap contributors"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  <MapRouteOverlay
                    points={routeLatLngs as LatLngTuple[]}
                    markerRadius={markerRadius}
                    plane={planeProgress}
                    popupSegments={popupSegments}
                    popupRoot={mapModalContentEl}
                  popupLabels={{
                    trip: intl.formatMessage(OrderRouteCharterCardMessages.mapPopupTrip),
                    departure: intl.formatMessage(OrderRouteCharterCardMessages.mapPopupDeparture),
                    arrival: intl.formatMessage(OrderRouteCharterCardMessages.mapPopupArrival),
                  }}
                  />
                </MapContainer>
              </MapInnerWrapper>
            </MapWrapper>
          </MapModalBody>
        </MapModalContent>
      </MapModal>
    </OrderCardWrapper>
  );
};
